import { Pipe, PipeTransform } from '@angular/core'
import { getPortalRuleAPIName, PortalRuleAPI } from '@mmx/shared'

@Pipe({
  name: 'portalRuleAPIName',
  standalone: false,
  pure: true,
})
export class PortalRuleAPINamePipe implements PipeTransform {
  transform(value: PortalRuleAPI): string {
    return getPortalRuleAPIName(value)
  }
}
